import { render } from "./ProfileSettingsComponent.vue?vue&type=template&id=aeebac0a&scoped=true"
import script from "./ProfileSettingsComponent.vue?vue&type=script&lang=js"
export * from "./ProfileSettingsComponent.vue?vue&type=script&lang=js"

import "./ProfileSettingsComponent.vue?vue&type=style&index=0&id=aeebac0a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aeebac0a"]])

export default __exports__